export default __webpack_public_path__ + "static/media/Blade of the Enslaving Opiate.d2bbd106.jpg";